import React from 'react';
import { Grid, TextField } from '@mui/material';
import { FormSection, SectionTitle, FieldRow, FieldTitle } from './StyledComponents';
import CustomDatePicker from '../../../Widgets/CustomDates/CustomDatePicker/CustomDatePicker.js';

const CustomsAgentInvoiceSection = ({
    direction,
    t,
    formData,
    handleInputChange,
    validationErrors
}) => {
    return (
        <FormSection>
            <SectionTitle dir={direction}>{t('CustomsAgentInvoice')}</SectionTitle>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <FieldRow dir={direction}>
                        <FieldTitle dir={direction}>{t('InvoiceNumber')}</FieldTitle>
                        <TextField
                            dir={direction}
                            size="small"
                            sx={{ flex: 1 }}
                            value={formData.invoiceNumber}
                            onChange={(e) => handleInputChange('invoiceNumber', e.target.value)}
                            error={!!validationErrors.invoiceNumber}
                            helperText={validationErrors.invoiceNumber}
                        />
                    </FieldRow>
                </Grid>
                <Grid item xs={12}>
                    <FieldRow dir={direction}>
                        <FieldTitle dir={direction}>{t('InvoiceDate')}</FieldTitle>
                        <CustomDatePicker
                            date={formData.invoiceDate ? formData.invoiceDate : null}
                            onDateChange={(date) => handleInputChange('invoiceDate', date)}
                            height="42px"
                            width="230px"
                            error={!!validationErrors.invoiceDate}
                            helperText={validationErrors.invoiceDate}
                        />
                    </FieldRow>
                </Grid>
                <Grid item xs={12}>
                    <FieldRow dir={direction}>
                        <FieldTitle dir={direction}>{t('Commission')}</FieldTitle>
                        <TextField
                            dir={direction}
                            size="small"
                            sx={{ flex: 1 }}
                            type="number"
                            value={formData.commission}
                            onChange={(e) => handleInputChange('commission', e.target.value)}
                            error={!!validationErrors.commission}
                            helperText={validationErrors.commission}
                        />
                    </FieldRow>
                </Grid>
                <Grid item xs={12}>
                    <FieldRow dir={direction}>
                        <FieldTitle dir={direction}>{t('StorageAtCustoms')}</FieldTitle>
                        <TextField
                            dir={direction}
                            size="small"
                            sx={{ flex: 1 }}
                            type="number"
                            value={formData.storageAtCustoms}
                            onChange={(e) => handleInputChange('storageAtCustoms', e.target.value)}
                            error={!!validationErrors.storageAtCustoms}
                            helperText={validationErrors.storageAtCustoms}
                        />
                    </FieldRow>
                </Grid>
                <Grid item xs={12}>
                    <FieldRow dir={direction}>
                        <FieldTitle dir={direction}>{t('SeaAirFreight')}</FieldTitle>
                        <TextField
                            dir={direction}
                            size="small"
                            sx={{ flex: 1 }}
                            type="number"
                            value={formData.seaAirFreight}
                            onChange={(e) => handleInputChange('seaAirFreight', e.target.value)}
                            error={!!validationErrors.seaAirFreight}
                            helperText={validationErrors.seaAirFreight}
                        />
                    </FieldRow>
                </Grid>
                <Grid item xs={12}>
                    <FieldRow dir={direction}>
                        <FieldTitle dir={direction}>{t('VariousVatLiable')}</FieldTitle>
                        <TextField
                            dir={direction}
                            size="small"
                            sx={{ flex: 1 }}
                            type="number"
                            value={formData.variousVatLiable}
                            onChange={(e) => handleInputChange('variousVatLiable', e.target.value)}
                            error={!!validationErrors.variousVatLiable}
                            helperText={validationErrors.variousVatLiable}
                        />
                    </FieldRow>
                </Grid>
                <Grid item xs={12}>
                    <FieldRow dir={direction}>
                        <FieldTitle dir={direction}>{t('VariousVatExempt')}</FieldTitle>
                        <TextField
                            dir={direction}
                            size="small"
                            sx={{ flex: 1 }}
                            type="number"
                            value={formData.variousVatExempt}
                            onChange={(e) => handleInputChange('variousVatExempt', e.target.value)}
                            error={!!validationErrors.variousVatExempt}
                            helperText={validationErrors.variousVatExempt}
                        />
                    </FieldRow>
                </Grid>
                <Grid item xs={12}>
                    <FieldRow dir={direction}>
                        <FieldTitle dir={direction}>{t('RoundingDifference')}</FieldTitle>
                        <TextField
                            dir={direction}
                            size="small"
                            sx={{ flex: 1 }}
                            type="number"
                            value={formData.roundingDifference}
                            onChange={(e) => handleInputChange('roundingDifference', e.target.value)}
                            error={!!validationErrors.roundingDifference}
                            helperText={validationErrors.roundingDifference}
                        />
                    </FieldRow>
                </Grid>
            </Grid>
        </FormSection>
    );
};

export default CustomsAgentInvoiceSection;